export default {
	created: function() {
		this.window.jusoCallBack = this.addressHandler.bind(this);
	},
	methods: {
		addressHandler: function() {
			this.setAddress(arguments[6], arguments[0], arguments[2]);
		}
	}
}